import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";
import "custom-event-polyfill/polyfill";
import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { ThroughProvider } from "react-through";
import { StyleguideApp } from "cw-styleguide-react";
import config from "./config";
import { createRoot } from "react-dom/client";
import { PageTracking } from "cw-styleguide-react";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <I18nextProvider i18n={i18next}>
    <ThroughProvider>
      <StyleguideApp config={config} env={process.env}>
        <PageTracking />
        <App />
      </StyleguideApp>
    </ThroughProvider>
  </I18nextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
